import { array, bool, func, object, string } from 'prop-types'
import { Modal } from '@opallabs/kuiper'

import './styles.scss'

const ActiveModal = (props) => {
  const {
    activeModalKey,
    classes = [],
    deactivateModalState,
    isModalActive,
    renderOptions,
  } = props
  const renderModalInternals = renderOptions[activeModalKey]
  if (!isModalActive || !renderModalInternals) return null

  return (
    <Modal
      visible={isModalActive}
      classes={['modal-with-options', ...classes]}
      onClose={deactivateModalState}
    >
      {renderModalInternals(props)}
    </Modal>
  )
}

ActiveModal.propTypes = {
  activeModalKey: string,
  classes: array,
  deactivateModalState: func,
  entity: object,
  isModalActive: bool,
  renderOptions: object,
}

export default ActiveModal
